import Inputmask from "inputmask";
import autosize from "autosize";

class InputModern {
	constructor(el, selector) {
		if (!el) return false;

		this.root = el;
		this.type = this.root.dataset.type || this.root.type;
		if (this.root.hasAttribute(`${selector}-inited`)) return false;
		this.root.setAttribute(`${selector}-inited`, true);

		this._matchHTML(selector);
		this.init();

		this.root.inputModule = this;
	}

	_matchHTML(selector) {

	}

	init() {
		this._initMasks();
		this._initTextAreaAutoheight();
		this._addListeners();
		this._initPlaceholder();
		this._checkChange();
	}

	_addListeners() {
		this.root.addEventListener('focus', e => {
			this.root.parentNode.classList.add('is-focused');
		});

		this.root.addEventListener('blur', e => {
			this.root.parentNode.classList.remove('is-focused');
			this._checkChange();
		});

		this.root.addEventListener('input', e => {
			this._checkChange();
		})
	}

	_initPlaceholder() {
		if (this.type === 'radio' || this.type === 'checkbox') return false;

		// let placeholder = this.root.getAttribute('placeholder');

		// if (!placeholder) {
		// 	this.root.nextElementSibling.remove();
		// 	return;
		// }

		// this.root.nextElementSibling.innerHTML = placeholder;

		this.root.parentNode.addEventListener('click', e => {
			this.root.focus();
		});
	}

	_checkChange() {
		let val = this.root.value;

		if (val) {
			this.root.parentNode.classList.add('is-changed');
		} else {
			this.root.parentNode.classList.remove('is-changed');
		}
	}

	_initMasks() {
		if (this.type === 'tel') {
			Inputmask({ "mask": arNextOptions['THEME']['PHONE_MASK'], 'showMaskOnHover': true }).mask(this.root);
			this.root.setAttribute('data-mask-inited', true);
			this.root.classList.add("phone");
		}
	}

	_initTextAreaAutoheight() {
		if (this.type !== 'textarea') return false;
		autosize(this.root);
	}

	setValue(value) {
		if (this.type === 'textarea') {
			this.root.innerText = value;
		} else if (this.type === 'radio') {
			this.root.checked = this.root.value === value;
		} else {
			this.root.value = value;
		}

		this.root.dispatchEvent(new Event('input'));
	}

	reset() {
		this.setValue('');
	}

}

class InputModernFactory {
	constructor(props) {
		this.inputs = [];

		[...document.querySelectorAll(`[${props.selector}]`)].forEach(el => {
			this.inputs.push(
				new InputModern(el, props.selector)
			);
		});
	}
}

export {InputModern, InputModernFactory}
